export const VirtualTeamsConstant = {

    //FILTER API
    VIRTUAL_TEAM_FILTER_LOADING: 'VIRTUAL_TEAM_FILTER_LOADING',
    VIRTUAL_TEAM_FILTER_DATA: 'VIRTUAL_TEAM_FILTER_DATA',
    VIRTUAL_TEAM_FILTER_ERROR: 'VIRTUAL_TEAM_FILTER_ERROR',
    
    //LIST API
    VIRTUAL_TEAM_LIST_LOADING: 'VIRTUAL_TEAM_LIST_LOADING',
    VIRTUAL_TEAM_LIST_DATA: 'VIRTUAL_TEAM_LIST_DATA',
    VIRTUAL_TEAM_LIST_ERROR: 'VIRTUAL_TEAM_LIST_ERROR',

    //CREATE API
    VIRTUAL_TEAM_CREATE_LOADING: 'VIRTUAL_TEAM_CREATE_LOADING',
    VIRTUAL_TEAM_CREATE_DATA: 'VIRTUAL_TEAM_CREATE_DATA',
    VIRTUAL_TEAM_CREATE_ERROR: 'VIRTUAL_TEAM_CREATE_ERROR',

    //EDIT API
    VIRTUAL_TEAM_EDIT_LOADING: 'VIRTUAL_TEAM_EDIT_LOADING',
    VIRTUAL_TEAM_EDIT_DATA: 'VIRTUAL_TEAM_EDIT_DATA',
    VIRTUAL_TEAM_EDIT_ERROR: 'VIRTUAL_TEAM_EDIT_ERROR',

    //TEAM LIST API
    VIRTUAL_TEAM_LISTMAIN_LOADING: 'VIRTUAL_TEAM_LISTMAIN_LOADING',
    VIRTUAL_TEAM_LISTMAIN_DATA: 'VIRTUAL_TEAM_LISTMAIN_DATA',
    VIRTUAL_TEAM_LISTMAIN_ERROR: 'VIRTUAL_TEAM_LISTMAIN_ERROR',

    //DELETE TEAM LIST API
    VIRTUAL_TEAM_DELETE_LOADING: 'VIRTUAL_TEAM_DELETE_LOADING',
    VIRTUAL_TEAM_DELETE_DATA: 'VIRTUAL_TEAM_DELETE_DATA',
    VIRTUAL_TEAM_DELETE_ERROR: 'VIRTUAL_TEAM_DELETE_ERROR',
    
    // MEMBER_LIST
    VIRTUAL_MEMBER_LIST_LOADING: 'VIRTUAL_MEMBER_LIST_LOADING',
    VIRTUAL_MEMBER_LIST_DATA: 'VIRTUAL_MEMBER_LIST_DATA',
    VIRTUAL_MEMBER_LIST_ERROR: 'VIRTUAL_MEMBER_LIST_ERROR',

    // MEMBER_ADD
    VIRTUAL_MEMBER_ADD_LOADING: 'VIRTUAL_MEMBER_ADD_LOADING',
    VIRTUAL_MEMBER_ADD_DATA: 'VIRTUAL_MEMBER_ADD_DATA',
    VIRTUAL_MEMBER_ADD_ERROR: 'VIRTUAL_MEMBER_ADD_ERROR',

    // MEMBER_UPDATE
    VIRTUAL_MEMBER_UPDATE_LOADING: 'VIRTUAL_MEMBER_UPDATE_LOADING',
    VIRTUAL_MEMBER_UPDATE_DATA: 'VIRTUAL_MEMBER_UPDATE_DATA',
    VIRTUAL_MEMBER_UPDATE_ERROR: 'VIRTUAL_MEMBER_UPDATE_ERROR',

    // MEMBER_SHARED_WITH
    VIRTUAL_MEMBER_SHARED_WITH_LOADING: 'VIRTUAL_MEMBER_SHARED_WITH_LOADING',
    VIRTUAL_MEMBER_SHARED_WITH_DATA: 'VIRTUAL_MEMBER_SHARED_WITH_DATA',
    VIRTUAL_MEMBER_SHARED_WITH_ERROR: 'VIRTUAL_MEMBER_SHARED_WITH_ERROR',

    // MEMBER_SHARE_TEAM
    VIRTUAL_MEMBER_SHARE_TEAM_LOADING: 'VIRTUAL_MEMBER_SHARE_TEAM_LOADING',
    VIRTUAL_MEMBER_SHARE_TEAM_DATA: 'VIRTUAL_MEMBER_SHARE_TEAM_DATA',
    VIRTUAL_MEMBER_SHARE_TEAM_ERROR: 'VIRTUAL_MEMBER_SHARE_TEAM_ERROR',

    // MEMBER_SHARE_DELETE
    VIRTUAL_MEMBER_SHARE_DELETE_LOADING: 'VIRTUAL_MEMBER_SHARE_DELETE_LOADING',
    VIRTUAL_MEMBER_SHARE_DELETE_DATA: 'VIRTUAL_MEMBER_SHARE_DELETE_DATA',
    VIRTUAL_MEMBER_SHARE_DELETE_ERROR: 'VIRTUAL_MEMBER_SHARE_DELETE_ERROR',


}


// WEBPACK FOOTER //
// ./src/_constants/VirtualTeams/VirtualTeams.constants.js